import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './Loading.module.css';
export const Loading = ({ size = 'medium', fullScreen = false, message, className, style }) => {
    const containerClass = [styles.container, fullScreen && styles.fullScreen, styles[size], className]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: containerClass, style: style, "data-testid": 'loading-container', children: [_jsxs("div", { className: styles.spinner, "data-testid": 'loading-spinner', children: [_jsx("div", { className: styles.circleBase }), _jsx("div", { className: styles.circleProgress })] }), message && (_jsx("p", { className: styles.message, "data-testid": 'loading-message', children: message }))] }));
};
export default Loading;
